module.exports = __webpack_public_path__ + "static/media/crm.78276b4f.png";